import { Typography } from "antd";
import { useTranslation } from "react-i18next";

import { TYPE_FILTER } from "@/constants/Tree";

export const getTableCategoryFilters = (t) =>
  TYPE_FILTER?.map(({ name }) => ({
    text: t(`global:${name.toLowerCase()}`),
    value: name,
  }));

const TableCategory = ({ type }) => {
  const { t } = useTranslation();
  return (
    <Typography.Text>
      {TYPE_FILTER?.find((filter) => filter.name.toLowerCase() === type)?.icon}
      {t(`global:${type}`)}
    </Typography.Text>
  );
};

export default TableCategory;
